import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

export class LoonBelastingPdf extends Component {
  render() {
    const styles = StyleSheet.create({
      page: {
        flexDirection: "column",
        padding: 14,
        marginTop: 20,
        fontSize: 12,
      },

      rapport: {
        display: "flex",
        flexDirection: "column",
        width: "100%"
      },

      even_row:{
        display: "flex",
        flexDirection: "row",
        backgroundColor: "#F5F5F5",
        padding: 4
      },

      odd_row:{
        display: "flex",
        flexDirection: "row",
        padding: 4
      },

      left:{
        width: "50%",
        padding: 6
      },
      right:{
        padding: 6,
        width: "20%",
        textAlign: 'right'
      },

      comp_info: {
        display: "flex",
        flexDirection: "row",
        width: "80%",
        justifyContent: "space-between",
        marginBottom: 15,
      },
      header: {
        fontSize: 14,
        marginBottom: 30,
      },
      small_p: {
        fontSize: 10,
        marginBottom: 2,
      },

      footer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: "auto",
        fontSize: 8,
        marginBottom: 20,
      },
    });

    const { data, company } = this.props;

    return (
      <Document>
        <Page size="A5" orientation="landscape" style={styles.page}>
          <View>
            <Text style={styles.header}>Loonbelasting Rapport</Text>
          </View>

          <View style={styles.comp_info}>
            <View style={styles.comp_info_p}>
              <Text style={styles.small_p}>Company naam</Text>
              <Text style={styles.comp_p}>{company.companyNaam}</Text>
            </View>
            <View style={styles.comp_info_p}>
              <Text style={styles.small_p}>Start datum salaris ronde</Text>
              <Text style={styles.comp_p}>
                {company.startDatumSalarisRonde}
              </Text>
            </View>
            <View style={styles.comp_info_p}>
              <Text style={styles.small_p}>Eind datum salaris ronde</Text>
              <Text style={styles.comp_p}>{company.eindDatumSalarisRonde}</Text>
            </View>
          </View>

          <View style={styles.rapport}>

            <View style={styles.even_row}>
              <View style={styles.left}>
                <Text style={styles.left_p}>1. Totaal verloond bedrag</Text>
              </View>
              <View style={styles.right}>
                <Text style={styles.right_p}>SRD {data.totaalVerloondBedrag}</Text>
              </View>
            </View>

            <View style={styles.odd_row}>
              <View style={styles.left}>
                <Text style={styles.left_p}>2a. Loonbelasting</Text>
              </View>
              <View style={styles.right}>
                <Text style={styles.right_p}>SRD {data.totaalLoonbelasting}</Text>
              </View>
            </View>

            <View style={styles.even_row}>
              <View style={styles.left}>
                <Text style={styles.left_p}>2b. Premie AOV</Text>
              </View>
              <View style={styles.right}>
                <Text style={styles.right_p}>SRD {data.totaalAOV}</Text>
              </View>
            </View>

            <View style={styles.odd_row}>
              <View style={styles.left}>
                <Text style={styles.left_p}>3. Totaal te betalen (2a+2b)</Text>
              </View>
              <View style={styles.right}>
                <Text style={styles.right_p}>SRD {data.totaalTeBetalen}</Text>
              </View>
            </View>

            <View style={styles.even_row}>
              <View style={styles.left}>
                <Text style={styles.left_p}>4. Aantal werknemers</Text>
              </View>
              <View style={styles.right}>
                <Text style={styles.right_p}>{data.aantalWerknemers}</Text>
              </View>
            </View>

          </View>
  
        </Page>
      </Document>
    );
  }
}

export default LoonBelastingPdf;
